import React, { useEffect } from 'react';
import * as echarts from 'echarts';

export interface AssetGoalsCardLineChartData {
  chartDataList: {
    name: string;
    expected: number;
    actual?: number;
  }[];
}

const AssetGoalsCardLineChart = ({ chartDataList }: AssetGoalsCardLineChartData) => {
  useEffect(() => {
    // 목표 관리 차트
    const goalChartDom = document.getElementById('goal-chart');
    if (goalChartDom) {
      const goalChart = echarts.init(goalChartDom);
      const goalOption = {
        animation: false,
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['목표 금액', '현재 금액'],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: chartDataList.map((chartData) => chartData.name),
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '목표 금액',
            type: 'line',
            data: chartDataList.map((chartData) => chartData.expected),
            lineStyle: {
              color: '#2196F3',
            },
            itemStyle: {
              color: '#2196F3',
            },
          },
          {
            name: '현재 금액',
            type: 'line',
            data: chartDataList.map((chartData) => chartData.actual ?? null),
            lineStyle: {
              color: '#4CAF50',
            },
            itemStyle: {
              color: '#4CAF50',
            },
            connectNulls: true,
          },
        ],
      };
      goalChart.setOption(goalOption);
      window.addEventListener('resize', () => {
        goalChart.resize();
      });
    }
  }, [chartDataList]);

  return <div id="goal-chart" className="w-full h-72"></div>;
};

export default AssetGoalsCardLineChart;
